module.exports = __webpack_public_path__ + "media/promo/advent/images/tree-bot-2f8424e274b3ca2055e7bd55898fcc10.png";